<header
  class="section-inset-t scroll-trigger header"
  id="header"
  [class.is--dark]="header?.darkHeader"
  [class.section-inset-y]="header?.darkHeader"
>
  <div *ngIf="header?.title" class="pt-topbar container">
    <div class="row">
      <span class="subtitle d-block mb-4 col-12" *ngIf="header?.subtitle">{{ header?.subtitle }}</span>
      <div class="position-relative" [ngClass]="!header?.fullWithTitle ? 'col-md-6' : 'col-lg-12'">
        <h2
          [class.mb-0]="!hasContent"
          [ngClass]="header?.fullWithTitle ? 'fs-display-1 lh-display-1' : 'fs-display-2 lh-display-2'"
          *ngIf="title || header?.title"
        >
          <ngx-dynamic-hooks
            [options]="{ sanitize: false, updateOnPushOnly: true }"
            [content]="title || header?.title || '' | highlight : 'fst-italic text-primary-gradient fw-bolder'"
            class="splitting splitting--letter-in"
          ></ngx-dynamic-hooks>

          <app-text-shape
            class="header__shape"
            [autoplay]="true"
            [shapeColor]="'secondary'"
            [type]="'standalone'"
            [class.header__shape--right]="header?.fullWithTitle"
          ></app-text-shape>
        </h2>
      </div>

      <div *ngIf="hasContent" [ngClass]="!header?.fullWithTitle ? 'col-md-6' : 'offset-md-4 col-md-8'">
        <p
          [ngClass]="header?.introTextBig ? 'h3' : 'h4'"
          [innerHTML]="header?.text"
          class="anim-fade-up delay--1"
          [class.mt-md-3]="!header?.fullWithTitle"
        >
          {{ header?.text }}
        </p>

        <fstr-link
          class="d-block anim-fade-up delay--2"
          *ngIf="header?.button?.url || header?.button?.routerLink"
          [button]="header?.button!"
          [cssClasses]="'mt-md-5 button button--primary-gradient has--dot'"
        ></fstr-link>
      </div>
    </div>
  </div>
</header>
